"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BasePatternFactory = _interopRequireDefault(require("../lib/BasePatternFactory"));

var _DomainRegex = _interopRequireDefault(require("../regex/DomainRegex"));

var _default = (0, _BasePatternFactory.default)({
  name: 'Domain',
  validator: function validator(input) {
    return _DomainRegex.default.test(input);
  }
});

exports.default = _default;
module.exports = exports.default;